export default __webpack_public_path__ + "static/media/acc.6b98de79.svg";